module.exports = __webpack_public_path__ + "static/img/animals5.1.37a84ea2.png";